export enum DealerType {
    RCI = 1,
    UCL = 2
}

export const DealerTypes = [
    [DealerType.RCI, 'RCI'],
    [DealerType.UCL, 'UCL']
]

export const getDealerTypeName = (type?: DealerType) => {
    return type ? DealerTypes.find(x => x[0] === type)?.at(1) : undefined;
}